import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";

import {
  convertArrayToString,
  convertArrayToStringWithCount,
  customTextColor,
} from "../../utils/const";
import {
  Box,
  CircularProgress,
  Grid,
  Pagination,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getJobTimeline } from "../../redux/jobTimeline/jobTimelineSlice";
import { allLocation } from "../../redux/common/locationSlice";
import { allSkill } from "../../redux/common/skillSlice";
import RecruiterApplyJobList from "../../components/containers/RecruiterApplyJobList";
import InfiniteScroll from "react-infinite-scroll-component";

const RecruiterApplyingDrawer = ({
  handleClose,
  show,
  jobDetailsListRow,
  handleShowJobDetails,
}) => {
  const jobtimeline = useSelector((state) => state.jobtimeline?.data);
  const skillData = useSelector((state) => state.skill.data);
  const jobtimelineStatus = useSelector((state) => state.jobtimeline?.status);
  const locations = useSelector((state) => state.location);
  const [page, setPages] = useState(jobtimeline?.jobs?.current_page || 1);
  const [jobData, setJobData] = useState([]);
  const [hasNext, setHasNext] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    has_next: false,
    has_previous: false,
    next_page: null,
    previous_page: null,
    total_pages: 1,
  });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getJobTimeline());
    dispatch(allLocation());
    dispatch(allSkill());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getJobTimeline(`page=${page}`));
  }, [page]);

  useEffect(() => {
    if (jobtimeline) {
      setPagination({
        current_page: jobtimeline?.current_page,
        has_next: jobtimeline?.has_next,
        has_previous: jobtimeline?.has_previous,
        next_page: jobtimeline?.next_page,
        previous_page: jobtimeline?.previous_page,
        total_pages: jobtimeline?.total_pages,
      });
    }
  }, [jobtimeline]);

  const handlePageChange = (event, value) => {
    setPages(value);
  };

  const getPreferSkillsNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          skillData?.locations?.find((location) => location.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getPreferLocationsNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getPreferLocationsNamesCount = (preferLocation) => {
    const names = preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      )
      ?.filter(Boolean);

    if (!names || names.length === 0) return "";

    const firstTwo = names.slice(0, 2);
    const remainingCount = names.length - 2;

    return remainingCount > 0
      ? `${firstTwo.join(", ")} +${remainingCount}`
      : firstTwo.join(", ");
  };

  useEffect(() => {
    setPages(1);
    setJobData([]);
    fetchTimeline(1);
  }, []);

  const fetchTimeline = (pageNumber = 1) => {
    const query = `page=${pageNumber}`;

    dispatch(getJobTimeline(query)).then((res) => {
      if (res.payload?.jobs) {
        setJobData((prev) =>
          pageNumber === 1 ? res.payload.jobs : [...prev, ...res.payload.jobs]
        );
        setHasNext(res.payload.has_next);
      }
    });
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "55%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>
          <Typography>
            <b> Apply on IT Recruiter job </b>
          </Typography>
          <Typography>Get 100 credit on every acceptance</Typography>
        </span>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body
        id="offcanvasScroll"
        style={{ paddingTop: "0", overflowY: "auto", maxHeight: "80vh" }}
      >
        {jobtimelineStatus === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 230,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{ padding: "15px 0 0 0" }}
            >
              {jobtimeline?.jobs?.length > 0 ? (
                <InfiniteScroll
                  dataLength={jobData.length}
                  next={() => {
                    if (jobtimeline?.has_next) {
                      const nextPage = page + 1;
                      setPages(nextPage);
                      fetchTimeline(nextPage);
                    }
                  }}
                  hasMore={jobtimeline?.has_next}
                  loader={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 30,
                        marginTop: "20px",
                      }}
                    >
                      <CircularProgress size={30} color="info" />
                    </Box>
                  }
                  scrollableTarget="offcanvasScroll"
                  scrollThreshold={0.9}
                >
                  {jobData?.map((requirement, index) => {
                    return (
                      <RecruiterApplyJobList
                        key={index}
                        name={requirement?.job_title}
                        mode={convertArrayToStringWithCount(
                          requirement?.requirement_type
                        )}
                        date={requirement?.created_at}
                        client={getPreferLocationsNamesCount(
                          requirement?.location
                        )}
                        salary={requirement?.rate}
                        skills={
                          (requirement?.skills !== undefined &&
                            requirement?.skills !== null &&
                            requirement?.skills !== "" &&
                            getPreferSkillsNames(requirement?.skills)) ||
                          []
                        }
                        requirement={requirement}
                        type="job_post"
                        jobDetailsListRow={jobDetailsListRow}
                        handleShowJobDetails={handleShowJobDetails}
                      />
                    );
                  })}
                </InfiniteScroll>
              ) : (
                <h6 style={{ textAlign: "center" }}>No Requirement Found</h6>
              )}
            </Grid>
            {/* <Box
              sx={{
                textAlign: "right",
                marginTop: "20px",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <Pagination
                count={pagination.total_pages}
                page={page}
                onChange={handlePageChange}
                color="primary"
              />
            </Box> */}
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default RecruiterApplyingDrawer;
